import React from 'react'
import './ProgressBar.css'

const ProgressBar = (props) => {
    return (
        <div
            role="progressbar"
            className="progress"
            style={{
                backgroundColor: props.bgcolor,
                height: props.barheight,
                width: props.barwidth,
                padding: props.padding,
                margin: props.margin,
            }}
        >
            <div
                className={`progress-done ${props.classes}`}
                style={{
                    width: `${props.done}%`,
                    color: props.barcolor,
                    background: props.barcolor,
                    opacity: props.opacity,
                }}
            ></div>
        </div>
    )
}
export default ProgressBar
